module.exports = __webpack_public_path__ + "static/media/FUN88_Affiliate_Help_Page_Icon_Help.96e052d5.svg";